# Кнопки прокручивающие страницу на верх
class window.ButtonToTop
  constructor: ->
    @initScrollButtonPopup()
    @initScrollButtonMain()

    
  # Инициализация кнопки для всплывающего окна
  initScrollButtonPopup: ->

    $('.popup-overlay').scroll ->
      if $('.popup-overlay').scrollTop() > $(window).height() * 0.5
        $('.button-to-top--popup-page').css('display', 'block')
      else
        $('.button-to-top--popup-page').css('display', 'none')

    $('.button-to-top--popup-page').click ->
      $('.popup-overlay').animate {scrollTop: 0}, 1000

  # Инициализация кнопки для основного контента
  initScrollButtonMain: ->
    $(window).scroll ->
      if $(document).scrollTop() > $(window).height() * 0.5
        $('.js-button-to-top--main').css('display', 'block')
      else
        $('.js-button-to-top--main').css('display', 'none')

    $('.js-button-to-top--main').click ->
      $('html, body').animate { scrollTop: $('html').offset().top }, 1000


// WEBPACK FOOTER //
// ./assets/javascripts/app/buttom_to_top.coffee